import React from "react";
import PropTypes from "prop-types";
import getDate from "date-fns/getDate";

import Tooltip from "../tooltip/tooltip";

const NormalDay = ({ date }) => (
  <div className="oui-datepicker-custom-day">{date}</div>
);

NormalDay.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

NormalDay.displayName = "OrionDatePickerDayNormal";

const DayWithBullets = ({ date }) => (
  <div className="oui-datepicker-custom-day oui-highlighted-date">{date}</div>
);

DayWithBullets.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

DayWithBullets.displayName = "OrionDatePickerDayWithBullet";

const DayWithTooltipAndBullets = ({ date, tooltip }) => (
  <Tooltip text={tooltip}>
    <div className="oui-datepicker-custom-day oui-highlighted-date">{date}</div>
  </Tooltip>
);

DayWithTooltipAndBullets.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

DayWithTooltipAndBullets.displayName = "OrionDatePickerDayWithTooltipAndBullet";

function DatePickerDay({ highlight, date }) {
  let Day;
  if (highlight) {
    Day = highlight.tooltip ? DayWithTooltipAndBullets : DayWithBullets;
  } else {
    Day = NormalDay;
  }
  return <Day date={getDate(date)} tooltip={highlight && highlight.tooltip} />;
}

DatePickerDay.displayName = "OrionDatePickerDay";

DatePickerDay.propTypes = {
  date: PropTypes.instanceOf(Date),
  highlight: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

export { NormalDay, DayWithBullets, DayWithTooltipAndBullets };

export default DatePickerDay;
